import React, { Component, PropTypes } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';

import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, {FormBody, FormActions, DateInput, SelectInput, TextInput} from '../Form';
import {station} from '../../actions/api';

@inject('stationStore', 'hqcStore')
@observer
class Add extends Component {
    static propTypes = {
        route: PropTypes.shape().isRequired,
        stationStore: PropTypes.object.isRequired,
    }

    static contextTypes = {
        router: PropTypes.shape().isRequired,
    }

    @observable item = {
        selectedStation: '',
        selectedDataSeries: '',
    };

    slug = 'analysis/hqc/graph';
    title = 'Add Parameter';

    constructor(props) {
        super(props);

        this.handleSave = this.handleSave.bind(this);
    }

    @action
    componentDidMount() {
        const {setDataSeries, setParameters, selectedDataSeries} = this.props.hqcStore;

        this.props.stationStore.fetchItems().then(() => {
            if(this.props.location.query.station_id) {
                this.item.selectedStation = this.props.location.query.station_id;

                station.fetchDataSeries(this.props.location.query.station_id).then(parameters => {
                    setDataSeries(parameters);

                    if(selectedDataSeries.length > 0) {
                        const sameParam = parameters.find(p => p.name === selectedDataSeries[0].name);

                        this.item.selectedDataSeries = sameParam ? sameParam.id : "";

                    }
                });

                station.fetchParameters(this.props.location.query.station_id).then(res => {
                    setParameters(res);
                });
            }
        });
    }

    @action selectedStationChange = (e) => {
        const {hqcStore} = this.props;
        const {setDataSeries, setParameters} = hqcStore;

        this.item.selectedDataSeries = '';
        this.item.selectedStation = e.target.value;

        if(e.target.value !== '') {
            station.fetchDataSeries(e.target.value).then(parameters => {
                setDataSeries(parameters);
            });

            station.fetchParameters(e.target.value).then(res => {
                setParameters(res);
            });
        }
    }

    @action selectedDataSeriesChange = (e) => {
        this.item.selectedDataSeries =  e.target.value;
    };

    handleSave(e) {
        e.preventDefault();

        const {dataSeries, getParameterById} = this.props.hqcStore;
        const selectedDataSeries = dataSeries.find(item => +item.id === +this.item.selectedDataSeries);
        const selectedParameter = this.item.selectedDataSeries ? getParameterById(selectedDataSeries.parameter_id) : null;

        if(!this.props.hqcStore.selectedDataSeries.find(d => +d.station_id === +this.item.selectedStation && +d.id === +selectedDataSeries.id)) {
            this.props.hqcStore.setSelectedDataSeries([...this.props.hqcStore.selectedDataSeries, {
                station_id: this.item.selectedStation, ...selectedDataSeries,
                parameter: {...selectedParameter}
            }]);

            this.context.router.push(this.props.location.query.slug ? this.props.location.query.slug : this.slug);
        } else {
            alert('This data series for this station has already been selected!');
        }
    }

    render() {
        const { stationStore, hqcStore } = this.props;
        const { items, filterStations } = stationStore;
        const { dataSeries, getParameterById, filterDataSeries } = hqcStore;

        const selectedDataSeries = dataSeries.find(item => +item.id === +this.item.selectedDataSeries);
        const selectedParameter = this.item.selectedDataSeries ? getParameterById(selectedDataSeries.parameter_id) : null;

        // if (stationStore.isLoading) { return <Spinner />; }

        return (
            <Modal title={this.title} slug={this.props.location.query.slug ? this.props.location.query.slug : this.slug} handleSave={this.handleSave}>
                <Form>
                    <FormBody>
                        <SelectInput options={items}
                                     filterOptions={filterStations}
                                     label={"Station"}
                                     fields={{label: 'name', value: 'id'}}
                                     onChange={this.selectedStationChange}
                                     value={this.item.selectedStation}/>
                        <SelectInput options={dataSeries}
                                     filterOptions={filterDataSeries}
                                     label={"Parameter"}
                                     fields={{label: 'name', value: 'id'}}
                                     onChange={this.selectedDataSeriesChange}
                                     value={this.item.selectedDataSeries}/>
                        {this.item.selectedDataSeries !== '' && [
                            <TextInput key={'parameterCode'} readOnly={true} label={'Parameter Code'} value={selectedParameter ? selectedParameter.code : ''}/>,
                            <TextInput key={'parameterUnit'} readOnly={true} label={'Unit'} value={`${selectedDataSeries.parameter_unit.name}${selectedDataSeries.parameter_unit.symbol ? `(${selectedDataSeries.parameter_unit.symbol})` : ''}`}/>,
                        ]}
                    </FormBody>
                    <FormActions>
                        <button onClick={this.handleSave}>Add</button>
                    </FormActions>
                </Form>
            </Modal>
        );
    }
}

export default Add;



// WEBPACK FOOTER //
// ./src/components/HQC/Add.js